export enum CadQuoteLevel {
	None = 0,
	TwoDimensionalAndThreeDimensional = 40,
	TwoDimensional = 10,
	TwoDimensionalAndDrawing = 20,
	ThreeDimensional = 30,
	ThreeDimensionalAndDrawing = 35,
	Drawing = 50
}